const queryParams = (queries) => {
  return queries
    ? Object.keys(queries)
        .map((items) => `${items}=${queries[items]}`)
        .join("&")
    : "";
};


export {queryParams}